<template>
  <Page :pagination="pagination">
    <template #content>
      <p
        class="page-title cadidate_page_smaller_title"
        v-text="'extrait du rapport reçu par le talent'"
      />
      <div class="content-wrapper">
        <div class="cadidate_pdf" data-convert="candidate_profile">
          <div class="cadidate_pdf_profil">
            <img
              class="cadidate_pdf_profil_logo"
              :src="`/images/results/badge_${currentProfile}.svg`"
            />
            <div class="cadidate_pdf_profil_name">
              {{ $t(`candidate_profiles.${currentProfile}.title`) }}
            </div>
            <div class="cadidate_pdf_profil_subtitle">
              {{ $t(`candidate_profiles.${currentProfile}.subtitle`) }}
            </div>
            <p class="cadidate_pdf_profil_text">
              <span v-for="n in 11" :key="n">{{
                $t(`candidate_profiles.${currentProfile}.text${n}`)
              }}</span>
            </p>
          </div>
          <div class="cadidate_pdf_top3">
            <p class="cadidate_pdf_top3_title">
              {{ $t("candidate_profiles.discover3") }}
            </p>
            <div class="cadidate_pdf_top_block">
              <div class="cadidate_pdf_top_block_interior">
                <img
                  class="cadidate_pdf_top_medal"
                  :src="`/images/results/${gold_comp}_gold.svg`"
                />
                <div class="cadidate_pdf_top_block_interior_right">
                  <div class="cadidate_pdf_comp_title">
                    {{ $t(`candidate_profiles.${gold_comp}_title`) }}
                  </div>
                  <p class="cadidate_pdf_comp_text">
                    {{ $t(`candidate_profiles.${gold_comp}_text`) }}
                  </p>
                </div>
              </div>
            </div>
            <div class="cadidate_pdf_top_block">
              <div class="cadidate_pdf_top_block_interior">
                <img
                  class="cadidate_pdf_top_medal"
                  :src="`/images/results/${silver_comp}_silver.svg`"
                />
                <div class="cadidate_pdf_top_block_interior_right">
                  <div class="cadidate_pdf_comp_title">
                    {{ $t(`candidate_profiles.${silver_comp}_title`) }}
                  </div>
                  <p class="cadidate_pdf_comp_text">
                    {{ $t(`candidate_profiles.${silver_comp}_text`) }}
                  </p>
                </div>
              </div>
            </div>
            <div class="cadidate_pdf_top_block">
              <div class="cadidate_pdf_top_block_interior">
                <img
                  class="cadidate_pdf_top_medal"
                  :src="`/images/results/${bronze_comp}_bronze.svg`"
                />
                <div class="cadidate_pdf_top_block_interior_right">
                  <div class="cadidate_pdf_comp_title">
                    {{ $t(`candidate_profiles.${bronze_comp}_title`) }}
                  </div>
                  <p class="cadidate_pdf_comp_text">
                    {{ $t(`candidate_profiles.${bronze_comp}_text`) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cadidate_pdf_footnote">
          <div class="cadidate_pdf_footnote_text">
            {{ $t("candidate_profiles.footnote_text") }}
          </div>
        </div>
      </div>
    </template>
  </Page>
</template>

<script setup>
import Page from "../Page.vue";
import { computed } from "vue";

//Different profils
import ArchitectProfil from "@/views/game/results/profil_architect.vue";
import InventorProfil from "@/views/game/results/profil_inventor.vue";
import MinesweeperProfil from "@/views/game/results/profil_minesweeper.vue";
import PilotProfil from "@/views/game/results/profil_pilot.vue";
import NavigatorProfil from "@/views/game/results/profil_navigator.vue";
import BalancerProfil from "@/views/game/results/profil_balancer.vue";

const props = defineProps({
  pagination: {
    type: String,
    required: true,
  },
  results: {
    type: Object,
    required: true,
  },
});

// Get score and grade for the three modules
var gdss_score = props.results.MS_GDSS.score;
var adpt_score = props.results.MS_ADPT.score;
var rdpb_score = props.results.MS_RDPB.score;

var gold_comp;
var silver_comp;
var bronze_comp;

var currentProfile = "None";

if (rdpb_score >= gdss_score && gdss_score >= adpt_score) {
  //Architect Profil
  currentProfile = "architect";
  gold_comp = "rdpb";
  silver_comp = "gdss";
  bronze_comp = "adpt";
} else if (rdpb_score >= adpt_score && adpt_score >= gdss_score) {
  //Inventor Profil
  currentProfile = "inventor";
  gold_comp = "rdpb";
  silver_comp = "adpt";
  bronze_comp = "gdss";
} else if (gdss_score >= rdpb_score && rdpb_score >= adpt_score) {
  //Minesweeper Profil
  currentProfile = "minesweeper";
  gold_comp = "gdss";
  silver_comp = "rdpb";
  bronze_comp = "adpt";
} else if (gdss_score >= adpt_score && adpt_score >= rdpb_score) {
  //Pilot  Profil
  currentProfile = "pilot";
  gold_comp = "gdss";
  silver_comp = "adpt";
  bronze_comp = "rdpb";
} else if (adpt_score >= rdpb_score && rdpb_score >= gdss_score) {
  //Navigator  Profil
  currentProfile = "navigator";
  gold_comp = "adpt";
  silver_comp = "rdpb";
  bronze_comp = "gdss";
} else if (adpt_score >= gdss_score && gdss_score >= rdpb_score) {
  //Balancer Profil
  currentProfile = "balancer";
  gold_comp = "adpt";
  silver_comp = "gdss";
  bronze_comp = "rdpb";
}

const currentProfileComponent = computed(() => {
  switch (currentProfile) {
    case "architect":
      return ArchitectProfil;
    case "inventor":
      return InventorProfil;
    case "minesweeper":
      return MinesweeperProfil;
    case "pilot":
      return PilotProfil;
    case "navigator":
      return NavigatorProfil;
    case "balancer":
      return BalancerProfil;
    default:
      return null;
  }
});
</script>

<style>
.cadidate_page_smaller_title {
  font-size: 29px !important;
}

.cadidate_pdf {
  align-items: center;
  background-color: #1d1d1d;
  border: 2px solid;
  border-color: #eebf29;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}

.cadidate_pdf_profil {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cadidate_pdf_profil_logo {
  transform: scale(0.75);
  position: relative;
}

.cadidate_pdf_profil_name {
  color: #ffffff;
  font-family: "Bio Sans-Bold", Helvetica;
  font-size: 20px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  text-align: center;
  width: fit-content;
}

.cadidate_pdf_profil_subtitle {
  background-color: #f2cb36;
  padding: 5px 10px;
  color: #1d1d1d;
  text-transform: uppercase;
  font-family: "Bio Sans-Bold", Helvetica;
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
  margin-top: -1px;
}

.cadidate_pdf_profil_text {
  align-self: stretch;
  color: #ffffff;
  font-family: "Bio Sans-Regular", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  text-align: center;
}

.cadidate_pdf_top3 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cadidate_pdf_top3_title {
  align-self: stretch;
  color: #ffffff;
  font-family: "Bio Sans-Bold", Helvetica;
  font-size: 16px;
  font-weight: 700;
}

.cadidate_pdf_top_block {
  background-color: #0f0e0e;
  border: 1px solid;
  border-color: #464646;
  padding: 4px;
}

.cadidate_pdf_top_block_interior {
  display: flex;
}

.cadidate_pdf_top_medal {
  position: relative;
  transform: scale(0.65);
}

.cadidate_pdf_top_block_interior_right {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.cadidate_pdf_comp_title {
  color: #ffffff;
  font-family: "Bio Sans-Bold", Helvetica;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 600;
}

.cadidate_pdf_comp_text {
  color: #ffffff;
  font-family: "Bio Sans-Regular", Helvetica;
  font-size: 14px;
  text-align: left;
  padding-top: 3px;
}

.cadidate_pdf_footnote {
  background-color: #fefdf6;
  border: 1px solid #f2cb36;
  box-sizing: border-box;
  padding: 10px;
}

.cadidate_pdf_footnote_text {
  font-family: "Bio Sans-Regular", Helvetica;
  text-align: left;
  font-size: 15px;
}
</style>
